import { Redirect, Route } from "react-router-dom";
import { useAuth } from "../context/auth";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { accessToken, termAccept } = useAuth()
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!accessToken)
          return <Redirect to="/login" />
        if (!termAccept)
          return <Redirect to="/landing" />
        return Component && <Component {...props} />
      }}
    />
  );
};

export default PrivateRoute;
